module.exports = __webpack_public_path__ + "img/well_off.5248e92a.svg";